import laravelAxiosClient from "../laravelAxiosClient";
import { CreateTicketSupportPayload } from "../interfaces/ticket-support.interface";

export const createTicketSupport = async (payload: CreateTicketSupportPayload) => {
  const { data } = await laravelAxiosClient.post("/tickets-support", payload);
  return data;
};
